import React from "react";
import { Card, CardBody } from "reactstrap";


interface WidgetProps {
  atividades: number;
  dentro_do_prazo: number;
  fora_do_prazo: number;
  concluidas: number;
}

const Widget = ({ atividades, dentro_do_prazo, fora_do_prazo, concluidas }: WidgetProps) => {
  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <div className="d-flex" style={{ justifyContent: "space-between" }}>            
              <>
                <li style={{display: "flex",}}>
                  <div className="d-flex flex-column align-items-start">
                    <div className="flex-grow-1">
                      <p className="text-muted small mb-1">Total</p>
                      <h5 className="font-size-16 mb-0">{atividades}</h5>
                    </div>
                  </div>
                </li>
                <li style={{display: "flex",}}>
                  <div className="d-flex flex-column align-items-start">
                    <div className="flex-grow-1">
                      <p className="text-muted small mb-1">D. do Prazo</p>
                      <h5 className="font-size-16 mb-0">{dentro_do_prazo}</h5>
                    </div>
                  </div>
                </li>
                <li style={{display: "flex",}}>
                  <div className="d-flex flex-column align-items-start">
                    <div className="flex-grow-1">
                      <p className="text-muted small mb-1">F. do Prazo</p>
                      <h5 className="font-size-16 mb-0">{fora_do_prazo}</h5>
                    </div>
                  </div>
                </li>
                <li style={{display: "flex",}}>
                  <div className="d-flex flex-column align-items-start">
                    <div className="flex-grow-1">
                      <p className="text-muted small mb-1">Concluídas</p>
                      <h5 className="font-size-16 mb-0">{concluidas}</h5>
                    </div>
                  </div>
                </li>               
              </>
            
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default Widget;
